import { render, staticRenderFns } from "./ExtendedSearch.vue?vue&type=template&id=0fc399c6"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js"
import style0 from "./ExtendedSearch.vue?vue&type=style&index=0&id=0fc399c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports